import EBarHome from './EBarHome';

export default EBarHome;
